import {useParams} from 'react-router-dom'
import {useOffers} from './useOffers'
import Loading from '../../../../Common/Loading'
import {OfferTile} from './components/OfferTile'
import {Container} from './components/Container'
import {NoOffers} from './components/NoOffers'
import {InvestSelfBanner} from './components/InvestSelfBanner'
import {useViewer} from '../../../../../hooks/useViewer'

const DEFAULT_OFFER_NAME = 'Default'

export const PammManagerOffers = () => {
  const {accountId} = useParams<{accountId: string}>()
  const {error, loading, offers} = useOffers(Number(accountId))
  const {loading: loadingViewer, viewer} = useViewer()

  const pammManagerAccountId = viewer?.accounts.find((account) =>
    [
      'PAMMTauroMarketsManagerAccount',
      'PAMMTauroMarketsMauritiusManagerAccount',
      'PAMMTauroMarketsMT5ManagerAccount',
    ].includes(account.__typename),
  )?.id

  if (error) return null
  if (loading || loadingViewer) return <Loading />

  // Because we don't want to display the default offer
  const withoutDefaultOffers = offers.filter((offer) => offer.name !== DEFAULT_OFFER_NAME)

  if (withoutDefaultOffers.length === -1) {
    return <NoOffers />
  }

  return (
    <Container>
      <InvestSelfBanner pammManagerAccountId={pammManagerAccountId} />
      {withoutDefaultOffers.map((offer) => (
        <OfferTile key={offer.id} offer={offer} />
      ))}
    </Container>
  )
}
